module.exports = __webpack_public_path__ + "./docs/img/big-icon-constants.83091c188a476ef06388f801a1bd3ac4.svg";